export default "__VITE_ASSET__D7jB8xE___"